// 57 A2UI icon names → ADS icon component imports
// Using @atlaskit/icon/core/* new icon imports

import type React from 'react';

import AddIcon from '@atlaskit/icon/core/add';
import ArrowLeftIcon from '@atlaskit/icon/core/arrow-left';
import ArrowRightIcon from '@atlaskit/icon/core/arrow-right';
import AttachmentIcon from '@atlaskit/icon/core/attachment';
import CalendarIcon from '@atlaskit/icon/core/calendar';
import CameraIcon from '@atlaskit/icon/core/camera';
import CheckMarkIcon from '@atlaskit/icon/core/check-mark';
import CreditCardIcon from '@atlaskit/icon/core/credit-card';
import CrossIcon from '@atlaskit/icon/core/cross';
import DeleteIcon from '@atlaskit/icon/core/delete';
import DownloadIcon from '@atlaskit/icon/core/download';
import EditIcon from '@atlaskit/icon/core/edit';
import EmailIcon from '@atlaskit/icon/core/email';
import FolderIcon from '@atlaskit/icon/core/folder-closed';
import HomeIcon from '@atlaskit/icon/core/home';
import ImageIcon from '@atlaskit/icon/core/image';
import LocationIcon from '@atlaskit/icon/core/location';
import LockLockedIcon from '@atlaskit/icon/core/lock-locked';
import LockUnlockedIcon from '@atlaskit/icon/core/lock-unlocked';
import MenuIcon from '@atlaskit/icon/core/menu';
import NotificationIcon from '@atlaskit/icon/core/notification';
import PersonIcon from '@atlaskit/icon/core/person';
import PhoneIcon from '@atlaskit/icon/core/phone';
import PrinterIcon from '@atlaskit/icon/core/printer';
import QuestionCircleIcon from '@atlaskit/icon/core/question-circle';
import RefreshIcon from '@atlaskit/icon/core/refresh';
import SearchIcon from '@atlaskit/icon/core/search';
import SendIcon from '@atlaskit/icon/core/send';
import SettingsIcon from '@atlaskit/icon/core/settings';
import ShareIcon from '@atlaskit/icon/core/share';
import ShowMoreHorizontalIcon from '@atlaskit/icon/core/show-more-horizontal';
import ShowMoreVerticalIcon from '@atlaskit/icon/core/show-more-vertical';
import StarStarredIcon from '@atlaskit/icon/core/star-starred';
import StarUnstarredIcon from '@atlaskit/icon/core/star-unstarred';
import StatusErrorIcon from '@atlaskit/icon/core/status-error';
import StatusInformationIcon from '@atlaskit/icon/core/status-information';
import StatusWarningIcon from '@atlaskit/icon/core/status-warning';
import UploadIcon from '@atlaskit/icon/core/upload';
import PauseIcon from '@atlaskit/icon/core/video-pause';
import PlayIcon from '@atlaskit/icon/core/video-play';

type IconComponent = React.ComponentType<{ label: string; spacing?: 'none' | 'spacious' }>;

export const iconMap: Record<string, IconComponent> = {
	accountCircle: PersonIcon,
	add: AddIcon,
	arrowBack: ArrowLeftIcon,
	arrowForward: ArrowRightIcon,
	attachFile: AttachmentIcon,
	calendarToday: CalendarIcon,
	call: PhoneIcon,
	camera: CameraIcon,
	check: CheckMarkIcon,
	close: CrossIcon,
	delete: DeleteIcon,
	download: DownloadIcon,
	edit: EditIcon,
	event: CalendarIcon,
	error: StatusErrorIcon,
	favorite: StarStarredIcon,
	favoriteOff: StarUnstarredIcon,
	folder: FolderIcon,
	help: QuestionCircleIcon,
	home: HomeIcon,
	info: StatusInformationIcon,
	locationOn: LocationIcon,
	lock: LockLockedIcon,
	lockOpen: LockUnlockedIcon,
	mail: EmailIcon,
	menu: MenuIcon,
	moreVert: ShowMoreVerticalIcon,
	moreHoriz: ShowMoreHorizontalIcon,
	notifications: NotificationIcon,
	notificationsOff: NotificationIcon,
	pause: PauseIcon,
	payment: CreditCardIcon,
	person: PersonIcon,
	phone: PhoneIcon,
	photo: ImageIcon,
	play: PlayIcon,
	print: PrinterIcon,
	refresh: RefreshIcon,
	search: SearchIcon,
	send: SendIcon,
	settings: SettingsIcon,
	share: ShareIcon,
	star: StarStarredIcon,
	starOff: StarUnstarredIcon,
	starHalf: StarStarredIcon, // No half-star in ADS
	stop: PauseIcon, // Close approximation
	upload: UploadIcon,
	visibility: SearchIcon, // Approximate
	visibilityOff: CrossIcon, // Approximate
	volumeUp: PlayIcon, // Approximate — no dedicated volume icons
	volumeDown: PlayIcon,
	volumeMute: CrossIcon,
	volumeOff: CrossIcon,
	warning: StatusWarningIcon,
};
